import { render, staticRenderFns } from "./LabDetailsForm.template.vue?vue&type=template&id=70aff303&scoped=true&"
var script = {}
import style0 from "./LabDetailsForm.template.vue?vue&type=style&index=0&id=70aff303&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70aff303",
  null
  
)

export default component.exports